import React, { useEffect, useState, useRef } from 'react';
import { CircularProgress, Grid, Paper } from '@material-ui/core';
import ArtApi, { IBackEndResponseModel } from '../api/ArtApi';
import ErrorSnackbar from './ErrorSnackbar';


interface IChartProps {
    eventId: string;
    getChartFn: (eventId: string) => Promise<IBackEndResponseModel<any>>;
    onChartClick?: (anything: any) => void;
}

declare var Bokeh: any;
export function TaggingChart(props: IChartProps) {
    const [error, setError] = useState<string | null>(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [chart, setChart] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    const mountedRef = useRef(true);

    const eventID = props.eventId;
    const getChartFn = props.getChartFn;

    useEffect(() => {
        return () => { mountedRef.current = false; };
    }, []);

    useEffect(() => {
        (window as any).BokehCallbacks = {
            onChartClick: props.onChartClick,
        }
    }, [props.onChartClick]);

    useEffect(() => {
        let element = document.getElementById("chart");
        if (element !== null) {
            while (element.firstChild) {
                element.removeChild(element.firstChild);
            }
            if (chart !== null) {
                try {
                    Bokeh.embed.embed_item(chart);
                }
                catch (error) {
                    console.log(error);
                    setError(String(error));
                    setSnackbarOpen(true);
                }
            }
        }
    }, [chart]);

    useEffect(() => {
        setIsLoading(true);
        getChartFn(eventID)
            .then(response => {
                if (!mountedRef.current) return;
                setChart(response.response);
                setIsLoading(false);
            })
            .catch(error => {
                if (!mountedRef.current) return;
                setError(error.message);
                setSnackbarOpen(true);
                setIsLoading(false);
            });
    }, [eventID, getChartFn]);

    return (
        <Grid item xs={12} md={12} lg={12}>
            <h2>Chart</h2>
            <Paper className="paper">
                {isLoading && <CircularProgress color="secondary" />}
                <ErrorSnackbar message={error} open={snackbarOpen} onClose={() => setSnackbarOpen(false)} />
                <div id='chart' className="bk-root" ></div>
            </Paper>
        </Grid>
    )
}
